
import { Vue, Options } from "vue-class-component";
@Options({
  props: {
    titleName: String
  }
})
export default class LotteryTitle extends Vue {}
